<template>
	<div style="width: 880px;margin: 70px auto;" class="clearfix">
		<bar :show="true" :totalMoney="money" :activity="activityId" :activityName="activityName" :activityLimit="activityLimit" :surplusLimit="surplusLimit"></bar>
		<div class="introduce-div"><span style="font-size: 14px;float: left">{{form.skuCode}}</span></div>
		<div class="vehicle-box clearfix">
			<div class="vehicle-span">
				<span>限购数量：{{ form.limitCount }}</span>
			</div>
		</div>
		<div class="header-box">
			<img style="width:200px;height:200px;" :src="$store.getters.imageUrl + '/' + form.productImgPath" alt="" />
			<div class="introduce-smallx-box">
				<span style="font-weight: bold;">{{ form.productName }}</span>
				<br />
				<span>{{ form.productNameEn }}</span>
				<br />
				<span style="font-size: 14px;">{{form.categoryName}}</span>
				<br />
				<div class="cotentbox">
					<div>
						<span style="font-size: 12px;color: #000000;padding-left: 0px;">市场价</span>
						<span style="float: right;font-size: 12px;color: #000000;text-decoration: line-through;">￥{{ form.salePrice }}</span>
					</div>
					<div>
						<span style="font-size: 12px;color: #000000;padding-left: 0px;">活动价</span>
						<span style="float: right;font-size: 16px;color: red;font-weight: bold;">￥{{ form.activityPrice}}</span>
					</div>
					<div>
						<span style="font-size: 12px;color: #000000;padding-left: 0px;">折扣</span>
						<span style="float: right;font-size: 12px;color: #000000;">{{discount}}%</span>
					</div>
					<div>
						<span style="font-size: 12px;color: #000000;padding-left: 0px;">数量</span>
						<span style="float: right;font-size: 12px;color: #000000;">剩余{{ form.surplusCount}}件</span>
					</div>
				</div>
				<div>
				</div>
				<div style="margin-top: 20px;">
					<el-button :disabled="form.surplusCount===0" @click="begin" size="mini" id="introduce-button">加入购物车</el-button>
					<el-input-number size="mini" style="width:80px;" v-model="num" controls-position="right" :min="1" :max="maxNum"></el-input-number>
				</div>
			</div>
		</div>
		<div class="introduce-div-t">
				<el-tabs v-model="activeName">
					<el-tab-pane label="商品详情" name="first">
						<div style="text-align: left;">
							{{ form.productDescribe}}
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div style="height:160px;margin-top: 50px;">
				    <el-button @click="toOrder" type="primary">返回</el-button>
			</div>
	</div>
</template>

<script>
import bar from '@/components/bar.vue'
import { productInfo, saveCarInfo, carMoney } from '../api/service'

export default {
	data() {
		return {
			activityId: '',
			productId: '',
			activityName: '',
			activityLimit: '',
			surplusLimit: '',
			discount: 0,
			num: 1,
			maxNum: 1,
			activeName: 'first',
			money: 0,
			form: {
				productName: '',
				productNameEn: '',
				salePrice: '',
				activityPrice: '',
				surplusCount: '',
				activityCount: '',
				productImgPath: '',
				limitCount: '',
				productName: '',
				productDescribe: '',
				categoryName: '',
				skuCode: ''
			}
		};
	},
	methods: {
		toOrder () {
			this.$router.go(-1)
		},
		getTotal () {
			const params1 = {
				activityId: this.activityId,
				staffId: this.$store.getters.id
			}
			carMoney(params1).then(response => {
				if (response.data.success === true) {
					this.money = response.data.data
				} 
			}).catch(() => {
			})
		},
		begin() {
			const params = {
				staffId: this.$store.getters.id,
				activityId: this.activityId,
				productId: this.productId,
				buyCount: this.num
			}
			saveCarInfo(params).then((response) => {
				if (response.data.success === true) {
					this.getTotal()
				} else {
					this.$alert('添加失败', '提示', {
						confirmButtonText: '确定',
					});
				}
			}).catch(() => {
					this.$message({ type: 'warning', message: '添加失败!' })
			})
			const params1 = {
				activityId: this.activityId,
				staffId: this.$store.getters.id
			}
			carMoney(params1).then(response => {
				if (response.data.success === true) {
					this.money = response.data.data
				} 
			}).catch(() => {
			})
		},
		fetchData () {
			const params = {
				activityId: this.activityId,
				productId: this.productId
			}
			productInfo(params).then(response => {
				if (response.data.success === true) {
					this.form.productName = response.data.data.productName
					this.form.productNameEn = response.data.data.productNameEn
					this.form.salePrice = response.data.data.salePrice
					this.form.activityPrice = response.data.data.activityPrice
					this.form.surplusCount = response.data.data.surplusCount
					this.form.activityCount = response.data.data.activityCount
					this.form.productImgPath = response.data.data.productImgPath
					this.form.productDescribe = response.data.data.productDescribe
					this.form.limitCount = response.data.data.limitCount
					this.form.categoryName = response.data.data.categoryName
					this.form.skuCode = response.data.data.skuCode
					this.discount = (response.data.data.activityPrice/response.data.data.salePrice).toFixed(2) * 100
					this.maxNum = this.form.limitCount < this.form.surplusCount ? this.form.limitCount : this.form.surplusCount
				} 
			}).catch(() => {
			})
		}
	},
	created() {
		this.activityId = this.$route.query.activityId
		this.productId = this.$route.query.productId
		this.activityName = this.$route.query.activityName
		this.activityLimit = this.$route.query.activityLimit
		this.surplusLimit = this.$route.query.surplusLimit
		this.fetchData()
	},
	components: {
		bar
	}
};
</script>

<style scoped>
.cotentbox {
	width: 212px;
	height: 110px;
	border-bottom: 1px solid #000000;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
}
li {
	list-style: none;
}
a {
	text-decoration: none;
}
.header-box {
	display: flex;
	width: 700px;
	justify-content: space-between;
}
.clearfix:after {
	content: '';
	display: block;
	clear: both;
}
.meorder-li li {
	display: inline-block;
	margin: 7px 17px 0 30px;
	font-size: 12px;
}
.list-bar-ui {
	text-align: left;
}
.list-bar-ui li {
	list-style: none;
	color: white;
	font-weight: 200;
	margin-left: 20px;
	cursor: pointer;
	display: inline-block;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	float: right;
	width: 209px;
	margin-top: 8px;
	padding-right: 300px;
}

.car-bar-box {
	cursor: pointer;
	width: 30px;
	height: 30px;
	background-image: url(../assets/img/cheo.png);
	background-size: 100%;
	background-repeat: no-repeat;
	position: absolute;
	top: 3px;
	right: 90px;
}
.vehicle-head-p {
	font-size: 12px;
	color: #000000;
	display: inline-block;
	float: left;
	padding: 5px 0 0 9px;
}
.vehicle-head-p-p {
	font-size: 12px;
	color: #000000;
	display: inline-block;
	position: absolute;
	bottom: 70px;
	left: 9px;
}
.vehicle-p-box {
	text-align: left;
	margin-left: 30px;
	float: right;
}
.vehicle-p-box p {
	font-size: 12px;
	color: #000000;
	padding-right: 31px;
	display: inline-block;
}
.vehicle-p-boxt p {
	font-size: 16px;
	color: #000000;
	padding-right: 30px;
	display: inline-block;
	color: red;
	font-weight: bold;
}
.vehicle-p-boxt {
	text-align: left;
	margin-left: 30px;
	float: right;
}
#vehicle-buttontt {
	background-color: pink;
	color: white;
}
#introduce-button {
	background-color: #be0f34;
	color: white;
	margin-right: 10px;
}
.introduce-h {
	font-size: 14px;
	position: absolute;
	left: 15px;
	bottom: 0;
	width: 56px;
	height: 20px;
	border-bottom: 1px solid red;
}
.introduce-input {
	width: 83px;
	position: absolute;
	bottom: -7px;
	left: 118px;
}
.introduce-div {
	width: 1000px;
	height: 30px;
	margin-top: 20px;
}
.introduce-div-t {
	width: 700px;
	height: 30px;
	/* margin-top: 40px; */
	/* 	position: absolute;
	top: -206px;
	right: 0; */
}
.introduce-span {
	font-size: 14px;
	position: absolute;
	left: 98px;
	bottom: 0;
	width: 56px;
	height: 20px;
}
.introduce-span-t {
	font-size: 14px;
	position: absolute;
	left: 180px;
	bottom: 0;
	width: 56px;
	height: 20px;
}
.introduce-box {
	width: 220px;
	height: 200px;
	border: 1px solid #e5e5e5;
	position: relative;
}
.introduce-smallx-box {
	width: 220px;
	height: 222px;
	text-align: left;
}
.introduce-small-box {
	position: relative;
	top: -25px;
	/* top: -170px; */
	right: -440px;
	text-align: left;
}
.vehicle-box {
	width: 269px;
	height: 42px;
	float: right;
	background-color: #be0f34;
	margin: -48px -104px 0 0;
	color: white;
}
.vehicle-span {
	line-height: 42px;
	text-align: center;
	color: white;
	font-family: '黑体' !important;
}
</style>
